module.exports = __webpack_public_path__ + "static/img/advertisement4_1.9a4daf67.png";